import React from 'react';
import { Clock, RotateCw } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Friendly "still waking up" screen for Render free-tier cold starts.
 * Renders nothing until `timedOut` is true — then shows a card with a
 * retry button that calls `onRetry`. Stays within the page layout so
 * the user keeps their session and navigation state.
 */
export function LoadingTimeout({ timedOut, onRetry }) {
  if (!timedOut) return null;

  return (
    <div
      className="flex items-center justify-center min-h-[400px] px-4 animate-fade-in"
      data-testid="loading-timeout"
    >
      <div className="max-w-md w-full bg-white border-2 border-amber-200 rounded-2xl shadow-lg p-6 md:p-8 text-center">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <Clock size={32} className="text-amber-600" />
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3">
          Demorando mais que o esperado...
        </h3>
        <p className="text-base md:text-lg text-slate-600 mb-6 leading-relaxed">
          A conexão está lenta. Clique em tentar novamente ou aguarde alguns instantes.
        </p>
        <Button
          onClick={onRetry}
          className="w-full h-14 text-lg font-bold bg-[#047857] hover:bg-[#059669] rounded-xl shadow-md"
          data-testid="loading-timeout-retry"
        >
          <RotateCw size={20} className="mr-2" />
          Tentar Novamente
        </Button>
      </div>
    </div>
  );
}

export default LoadingTimeout;
